module.exports = __webpack_public_path__ + "static/media/about-us-card-icon--2.06b6e204.svg";